module.exports = __webpack_public_path__ + "static/media/library-sb.19c88b9b.svg";